import { render, staticRenderFns } from "./ChurnRateChartAdmin.vue?vue&type=template&id=025f438c"
import script from "./ChurnRateChartAdmin.vue?vue&type=script&lang=js"
export * from "./ChurnRateChartAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports